import React from "react";
import styled from "styled-components";
import DailyTaskManager from "../components/DailyTaskManager";
import Streaks from "../components/Streaks";
import ProgressChart from "../components/ProgressChart";
import IndProgressChart from "../components/IndProgressChart";
import ClientsTable from "../components/ClientsTable";
import asitesLogo from "../assets/asitesLogoDL.png";
import EmployeesTable from "../components/EmployeesTable";
import Stats from "../components/Stats";
import DailyTracker from "../components/DailyTracker";
import WealthTracker from "../components/WealthTracker";
import planner from "../assets/Planner.png";
import ToDoList from "../components/ToDoList";
import HabitTracker from "../components/HabitTracker";
import HabitChart from "../components/HabitChart";
import IncomeTracker from "../components/IncomeTracker";
import Quote from "../components/Quote";
import SpendingsIncomeTracker from "../components/IncomeTracker";
import IncomeExpenseTracker from "../components/IncomeTracker";
import Stats2 from "../components/Stats2";
import GoalTracker from "../components/GoalTracker";
import HabitAnalysis from "../components/HabitAnalysis";

const Home = () => {
  return (
    <Container>
      <h1 className="mainTitle">
        <img src={planner} alt="" />
      </h1>
      <Quote />
      <div className="daily div">
        <HabitTracker />
        <div className="merche stats">
          <Streaks />
          <GoalTracker />
        </div>
        <div className="merche2">
          <ToDoList />
          <IncomeExpenseTracker />
        </div>
      </div>
      <HabitAnalysis />
      {/* <div className="banner">
        <HabitTracker />
        <div className="other">
          <Streaks />
          <ToDoList />
        </div>
      </div>
      <GoalTracker />
      <div className="mainTitle">
        <img src={asitesLogo} alt="" />
      </div>
      <div className="asites div">
        <ClientsTable />
        <EmployeesTable />
      </div>
      <div className="finance div">
        <DailyTracker />
        <WealthTracker />
      </div>
      <div className="div todo">
        <HabitChart />
      </div> */}
    </Container>
  );
};
const Container = styled.div`
  margin-left: 240px;
  .mainTitle {
    text-align: center;
    padding: 1em;
    margin: auto;
    img {
      width: 200px;
      margin-top: 10px;
    }
  }
  .merche {
    display: flex;
    flex-direction: column;
    width: 25%;
  }
  .merche2 {
    display: flex;
    flex-direction: column;
    width: 35%;
  }
  .stats {
    gap: 1em;
  }
  .div {
    padding: 0 3%;
    display: flex;
    /* justify-content: center; */
    align-items: stretch;
    gap: 2em;
    flex-wrap: wrap;
  }
  .banner {
    padding: 0 3%;
    display: flex;
    justify-content: center;
    gap: 2em;
    flex-wrap: wrap;
  }
  .finance {
    margin-top: 1.4em;
  }
  .todo {
    margin: 3em 0;
  }
  @media (max-width: 920px) {
    margin-left: 0;
    margin-top: 2em;
    /* .stats {
      width: 10%;
    } */
  }
  @media (max-width: 1605px) {
    margin-left: 70px;
  }
  @media (max-width: 920px) {
    margin-left: 0;
    div {
      gap: 1em;
    }
    .stats {
      width: 37%;
    }
  }
  @media (max-width: 1440px) {
    .stats {
      width: 37%;
    }
    .merche2 {
      flex-direction: row;
      width: 100%;
      justify-content: stretch;
    }
  }
  @media (max-width: 850px) {
    .stats {
      width: 100%;
    }
    .merche2 {
      width: 100%;
    }
  }
`;

export default Home;
